import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-73a94e47")

_pushScopeId("data-v-73a94e47")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Schedule")
const _hoisted_2 = { class: "page" }
const _hoisted_3 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Schedule")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("You're in!")
const _hoisted_7 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Schedule")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("You're in!")
const _hoisted_10 = /*#__PURE__*/_createVNode("p", { class: "text-md" }, " No live classes scheduled for today :( ", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Navbar = _resolveComponent("Navbar")
  const _component_ion_back_button = _resolveComponent("ion-back-button")
  const _component_ion_buttons = _resolveComponent("ion-buttons")
  const _component_ion_title = _resolveComponent("ion-title")
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")
  const _component_ion_header = _resolveComponent("ion-header")
  const _component_ion_img = _resolveComponent("ion-img")
  const _component_ion_card = _resolveComponent("ion-card")
  const _component_ion_col = _resolveComponent("ion-col")
  const _component_ion_row = _resolveComponent("ion-row")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_label = _resolveComponent("ion-label")
  const _component_ion_spinner = _resolveComponent("ion-spinner")
  const _component_ion_text = _resolveComponent("ion-text")
  const _component_ion_avatar = _resolveComponent("ion-avatar")
  const _component_ion_item = _resolveComponent("ion-item")
  const _component_ion_list = _resolveComponent("ion-list")
  const _component_ion_infinite_scroll_content = _resolveComponent("ion-infinite-scroll-content")
  const _component_ion_infinite_scroll = _resolveComponent("ion-infinite-scroll")
  const _component_ion_grid = _resolveComponent("ion-grid")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_bottombar = _resolveComponent("bottombar")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_header, { class: "ion-no-border" }, {
        default: _withId(() => [
          (_ctx.isWeb)
            ? (_openBlock(), _createBlock(_component_Navbar, { key: 0 }))
            : _createCommentVNode("", true),
          (!_ctx.isWeb)
            ? (_openBlock(), _createBlock(_component_ion_toolbar, { key: 1 }, {
                default: _withId(() => [
                  _createVNode(_component_ion_buttons, { slot: "start" }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_back_button, {
                        icon: "chevron-back",
                        text: "",
                        color: "medium",
                        "default-href": "classes"
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_title, { color: "medium" }, {
                    default: _withId(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_2, [
            _createVNode(_component_ion_grid, null, {
              default: _withId(() => [
                _createVNode(_component_ion_row, { class: "category-icon-container" }, {
                  default: _withId(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.categories, (category, index) => {
                      return (_openBlock(), _createBlock(_component_ion_col, {
                        sizeLg: "3",
                        sizeSm: "3",
                        size: "3",
                        key: category.name + index
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_ion_card, {
                            color: "light",
                            class: ["category-icon-card", {
									'active-category': category.name == _ctx.selectedCategory,
								}],
                            button: "",
                            onClick: ($event: any) => (_ctx.changeCategory(category.name))
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_ion_img, {
                                class: ["category-icon", {
										'active-category-img': category.name == _ctx.selectedCategory,
									}],
                                src: category.icon
                              }, null, 8, ["class", "src"]),
                              _createVNode("span", {
                                class: [{
										'active-category-text': category.name == _ctx.selectedCategory,
									}, "text-sm icon-text"],
                                color: "medium"
                              }, _toDisplayString(category.name), 3)
                            ]),
                            _: 2
                          }, 1032, ["class", "onClick"])
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_row, null, {
                  default: _withId(() => [
                    _createVNode(_component_ion_col, {
                      sizeLg: "6",
                      offsetLg: "3"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_ion_row, { class: "row-border text-center" }, {
                          default: _withId(() => [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.days, (day, index) => {
                              return (_openBlock(), _createBlock(_component_ion_col, {
                                size: "2",
                                key: index,
                                class: "text-left"
                              }, {
                                default: _withId(() => [
                                  (day == _ctx.daySelected)
                                    ? (_openBlock(), _createBlock(_component_ion_button, {
                                        key: 0,
                                        size: "small",
                                        fill: "clear",
                                        color: "primary",
                                        class: "text-sm",
                                        onClick: ($event: any) => (_ctx.selectDay(index))
                                      }, {
                                        default: _withId(() => [
                                          _createTextVNode(_toDisplayString(day.format("ddd D")), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"]))
                                    : (_openBlock(), _createBlock(_component_ion_button, {
                                        key: 1,
                                        size: "small",
                                        fill: "clear",
                                        color: "secondary",
                                        class: "text-sm",
                                        onClick: ($event: any) => (_ctx.selectDay(index))
                                      }, {
                                        default: _withId(() => [
                                          _createTextVNode(_toDisplayString(day.format("ddd D")), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"]))
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_row, null, {
                  default: _withId(() => [
                    _createVNode(_component_ion_col, {
                      sizeLg: "6",
                      offsetLg: "3"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_ion_infinite_scroll, null, {
                          default: _withId(() => [
                            _createVNode(_component_ion_infinite_scroll_content, null, {
                              default: _withId(() => [
                                _createVNode(_component_ion_label, null, {
                                  default: _withId(() => [
                                    _createTextVNode(_toDisplayString(_ctx.daySelected.format("dddd, MMMM Do")), 1)
                                  ]),
                                  _: 1
                                }),
                                _hoisted_3,
                                (_ctx.loading)
                                  ? (_openBlock(), _createBlock(_component_ion_card, { key: 0 }, {
                                      default: _withId(() => [
                                        _createVNode(_component_ion_spinner, { name: "crescent" })
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (_ctx.filteredClasses.length != 0 && !_ctx.loading)
                                  ? (_openBlock(), _createBlock(_component_ion_card, {
                                      key: 1,
                                      style: {"padding":"0","margin":"0"}
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_ion_list, null, {
                                          default: _withId(() => [
                                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.filteredClasses, (classs, index) => {
                                              return (_openBlock(), _createBlock("div", {
                                                color: "light",
                                                key: index
                                              }, [
                                                (classs.isLive)
                                                  ? (_openBlock(), _createBlock(_component_ion_item, { key: 0 }, {
                                                      default: _withId(() => [
                                                        _createVNode(_component_ion_text, {
                                                          slot: "start",
                                                          class: "text-sm"
                                                        }, {
                                                          default: _withId(() => [
                                                            _createTextVNode(_toDisplayString(_ctx.toLocalTime(classs.dateMoment).format("hh:mm A")), 1)
                                                          ]),
                                                          _: 2
                                                        }, 1024),
                                                        (_ctx.isWeb)
                                                          ? (_openBlock(), _createBlock(_component_ion_avatar, {
                                                              key: 0,
                                                              slot: "start"
                                                            }, {
                                                              default: _withId(() => [
                                                                _createVNode("img", {
                                                                  src: classs.trainerData.imgURL
                                                                }, null, 8, ["src"])
                                                              ]),
                                                              _: 2
                                                            }, 1024))
                                                          : _createCommentVNode("", true),
                                                        _createVNode(_component_ion_text, {
                                                          slot: "start",
                                                          class: "text-sm text-left"
                                                        }, {
                                                          default: _withId(() => [
                                                            _createVNode("strong", null, _toDisplayString(classs.name), 1),
                                                            _hoisted_4,
                                                            _createTextVNode(_toDisplayString(classs.trainerData.name), 1)
                                                          ]),
                                                          _: 2
                                                        }, 1024),
                                                        (!_ctx.isRegistered(classs.classID))
                                                          ? (_openBlock(), _createBlock(_component_ion_button, {
                                                              key: 1,
                                                              onClick: ($event: any) => (_ctx.openModal(classs)),
                                                              class: "text-sm",
                                                              color: "primary",
                                                              fill: "outline",
                                                              size: "block",
                                                              slot: "end"
                                                            }, {
                                                              default: _withId(() => [
                                                                _hoisted_5
                                                              ]),
                                                              _: 2
                                                            }, 1032, ["onClick"]))
                                                          : (_openBlock(), _createBlock(_component_ion_button, {
                                                              key: 2,
                                                              onClick: ($event: any) => (_ctx.openModal(classs)),
                                                              class: "text-sm",
                                                              color: "success",
                                                              fill: "outline",
                                                              size: "block",
                                                              slot: "end"
                                                            }, {
                                                              default: _withId(() => [
                                                                _hoisted_6
                                                              ]),
                                                              _: 2
                                                            }, 1032, ["onClick"]))
                                                      ]),
                                                      _: 2
                                                    }, 1024))
                                                  : _createCommentVNode("", true),
                                                (!classs.isLive && _ctx.isRegistered(classs.classID))
                                                  ? (_openBlock(), _createBlock(_component_ion_item, { key: 1 }, {
                                                      default: _withId(() => [
                                                        _createVNode(_component_ion_text, {
                                                          slot: "start",
                                                          class: "text-sm"
                                                        }, {
                                                          default: _withId(() => [
                                                            _createTextVNode(_toDisplayString(_ctx.toLocalTime(classs.dateMoment).format("hh:mm A")), 1)
                                                          ]),
                                                          _: 2
                                                        }, 1024),
                                                        (_ctx.isWeb)
                                                          ? (_openBlock(), _createBlock(_component_ion_avatar, {
                                                              key: 0,
                                                              slot: "start"
                                                            }, {
                                                              default: _withId(() => [
                                                                _createVNode("img", {
                                                                  src: classs.trainerData.imgURL
                                                                }, null, 8, ["src"])
                                                              ]),
                                                              _: 2
                                                            }, 1024))
                                                          : _createCommentVNode("", true),
                                                        _createVNode(_component_ion_text, {
                                                          slot: "start",
                                                          class: "text-sm text-left"
                                                        }, {
                                                          default: _withId(() => [
                                                            _createVNode("strong", null, _toDisplayString(classs.name), 1),
                                                            _hoisted_7,
                                                            _createTextVNode(_toDisplayString(classs.trainerData.name), 1)
                                                          ]),
                                                          _: 2
                                                        }, 1024),
                                                        (!_ctx.isRegistered(classs.classID))
                                                          ? (_openBlock(), _createBlock(_component_ion_button, {
                                                              key: 1,
                                                              onClick: ($event: any) => (_ctx.openModal(classs)),
                                                              class: "text-sm",
                                                              color: "primary",
                                                              fill: "outline",
                                                              size: "block",
                                                              slot: "end"
                                                            }, {
                                                              default: _withId(() => [
                                                                _hoisted_8
                                                              ]),
                                                              _: 2
                                                            }, 1032, ["onClick"]))
                                                          : (_openBlock(), _createBlock(_component_ion_button, {
                                                              key: 2,
                                                              onClick: ($event: any) => (_ctx.openModal(classs)),
                                                              class: "text-sm",
                                                              color: "success",
                                                              fill: "outline",
                                                              size: "block",
                                                              slot: "end"
                                                            }, {
                                                              default: _withId(() => [
                                                                _hoisted_9
                                                              ]),
                                                              _: 2
                                                            }, 1032, ["onClick"]))
                                                      ]),
                                                      _: 2
                                                    }, 1024))
                                                  : _createCommentVNode("", true)
                                              ]))
                                            }), 128))
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (_ctx.filteredClasses.length == 0 && !_ctx.loading)
                                  ? (_openBlock(), _createBlock(_component_ion_card, { key: 2 }, {
                                      default: _withId(() => [
                                        _hoisted_10
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }),
      (!_ctx.isWeb)
        ? (_openBlock(), _createBlock(_component_bottombar, { key: 0 }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
})